module.exports = __webpack_public_path__ + "img/top02.df6b957b.png";